export const leadSourceReferral = 'Referral'
export const leadSource = [
  'Google Search',
  'LinkedIn',
  'Facebook',
  leadSourceReferral,
  'Review Site',
  'Podcast',
  'Snowflake',
  'Event',
  'Other',
]
